import { useInView } from "../../components/inView/inView";
import { useLocale } from "../../locale-context";
import { AppLink, localizedPath } from "../../router";
import "./footer.css";

export default function Footer({ activePage }) {
  useInView();
  const { locale, t } = useLocale();
  const links = [
    ["about", "/about/"],
    ["skills", "/skills/"],
    ["projects", "/projects/"],
    ["journal", "/journal/"],
    ["contact", "/contact/"],
  ];
  return (
    <footer
      className="footer-container"
      data-animation='{"once":false,"delay":0}'
    >
      <div className="footer">
        <p>© {new Date().getFullYear()} Ricardo Beaujon</p>
        <nav className="nav-links link-right" aria-label={t.menu}>
          <ul id="links">
            {links.map(([name, path], index) => (
              <li key={name}>
                <AppLink
                  href={localizedPath(locale, path)}
                  className={activePage === name ? "active" : ""}
                >
                  {t.nav[index]}
                </AppLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </footer>
  );
}
